'use strict';

import angular from 'angular';

/**
 * @ngdoc service
 * @name observatoireApp.service:ConventionsMiniereService
 * @description
 * # ConventionsMiniereService
 * Service pour la gestion des conventions minières
 */
angular.module('observatoireApp')
  .service('ConventionsMiniereService', ['$http', '$q', function($http, $q) {
    
    // Conventions chargées depuis l'API (cache local pour les filtres)
    let conventionsCache = [];

    function rechercherDocuments(convention) {
      return (convention && convention.documents || []).filter(function(d) { return d && d.urlDocument; });
    }

    /**
     * Récupère toutes les conventions minières depuis l'API
     * @returns {Promise} Promesse contenant les conventions minières
     */
    this.getConventions = function() {
      return $http.get('/api/conventions-minieres').then(function(response) {
        conventionsCache = Array.isArray(response.data) ? response.data : [];
        return conventionsCache;
      });
    };

    /**
     * Récupère une convention minière par son ID
     * @param {number} id Identifiant de la convention
     * @returns {Promise} Promesse contenant la convention
     */
    this.getConventionById = function(id) {
      return $http.get('/api/conventions-minieres/' + id).then(function(response) {
        return response.data;
      });
    };

    /**
     * Documents de la convention disposant d'un lien réel
     */
    this.getDocuments = rechercherDocuments;

    /**
     * Récupère les régions uniques des conventions minières
     * @returns {Array<string>} Liste des régions
     */
    this.getRegions = function() {
      return [...new Set(conventionsCache.map(c => c.region).filter(Boolean))].sort();
    };

    /**
     * Récupère les substances minières uniques
     * @returns {Array<string>} Liste des substances
     */
    this.getSubstances = function() {
      const substances = conventionsCache
        .map(c => (c.substance || '').split(',').map(s => s.trim()))
        .flat()
        .filter(Boolean);
      return [...new Set(substances)].sort();
    };

    /**
     * Récupère les statuts uniques
     * @returns {Array<string>} Liste des statuts
     */
    this.getStatuts = function() {
      return [...new Set(conventionsCache.map(c => c.statut).filter(Boolean))].sort();
    };

    /**
     * Exporte les conventions au format Excel (XLSX)
     * @param {Array} donnees Conventions à exporter
     * @returns {Promise}
     */
    this.exporterExcel = function(donnees) {
      return $q.when(import('../utils/excel-export.js')).then(function(module) {
        const lignes = (donnees || []).map(function(c) {
          return {
            'Société': c.societe || '',
            'Projet': c.projet || '',
            'Substance': c.substance || '',
            'Région': c.region || '',
            'Date de signature': c.dateSignature ? String(c.dateSignature).substring(0, 10) : '',
            'Durée (ans)': c.duree || '',
            'Date de fin': c.dateFin ? String(c.dateFin).substring(0, 10) : '',
            'Statut': c.statut || '',
            'Superficie (km²)': c.superficie || '',
            'Investissement': c.investissement || '',
            'Emplois directs': c.emploisDirects || '',
            'Document': (rechercherDocuments(c)[0] || {}).urlDocument || ''
          };
        });
        return module.default.exportToExcel(lignes, 'conventions_minieres.xlsx');
      });
    };
  }]);
